import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {MiseEnPlaceModelService} from '../../../Models/YuChef/Mise-en-place/mise-en-place-model.service';
import {MiseEnPlaceFilters} from "../../../../Models/YuChef/Mise-en-place/mise-en-place-filters.model";

@Injectable({
  providedIn: 'root'
})
export class MiseEnPlaceApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: MiseEnPlaceModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener la Mise en place
   *
   */
  public getMiseEnPlace(params: MiseEnPlaceFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getMiseEnPlace', params).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }
}
